import { render } from "./SellersSection.vue?vue&type=template&id=51373b7a"
import script from "./SellersSection.vue?vue&type=script&lang=js"
export * from "./SellersSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__